import { ActionTakenPayload, ActionTakenType, CommandPayload, CommandPayloadCommandType, MessageType } from "@swivl-mono/types";
import React from "react";

import { ListItemData } from "../../ListItem";
import "./SystemEvent.css";

export interface SystemEventProps {
  item: ListItemData;
}

function getSystemEventText(item: ListItemData): string | null {
  const message = item.message;
  if (!message) {
    return null;
  }

  if (message.type === MessageType.StartConversation) {
    return "Conversation started";
  }

  if (message.type === MessageType.ActionTaken) {
    const payload = message.payload as ActionTakenPayload | undefined;
    const actionType = payload?.actionTaken?.type;
    if (actionType === ActionTakenType.URLSelected) {
      return "User selected a link";
    }
    if (actionType === ActionTakenType.OptionsSelected) {
      return "User selected options";
    }
    return "User selected an option";
  }

  if (message.type === MessageType.Command) {
    const payload = message.payload as CommandPayload | undefined;
    const commandType = payload?.type;
    const innerPayload = (payload?.payload ?? {}) as { url?: string; open?: boolean };

    if (commandType === CommandPayloadCommandType.NavigateTo) {
      return innerPayload.url ? `Redirected to ${innerPayload.url}` : "Redirected";
    }
    if (commandType === CommandPayloadCommandType.OpenOrClose) {
      return innerPayload.open ? "Chat opened" : "Chat closed";
    }
  }

  return null;
}

export class SystemEvent extends React.Component<SystemEventProps> {
  render() {
    const text = getSystemEventText(this.props.item);
    if (!text) {
      return null;
    }

    return (
      <div className="scc-SystemEvent">
        <div className="swivl-timestamp text-sm leading-4 text-grey-600">{text}</div>
      </div>
    );
  }
}
